import main from '@/locales/en/main';
import custom from '@/locales/en/custom';
import customers from '@/locales/en/customers';
import refund from '@/locales/en/refund';
import exchanges from '@/locales/en/exchanges';
import issue from '@/locales/en/issue';
import logs from '@/locales/en/logs';
import refundExchange from '@/locales/en/refundExchange';
import settings from '@/locales/en/settings';
import tasks from '@/locales/en/tasks';
import orders from '@/locales/en/orders';
import products from '@/locales/en/products';
import feedback from '@/locales/en/feedback';
import errors from '@/locales/en/errors';
import scanner from '@/locales/en/scanner';
import alerts from '@/locales/en/alerts';

export default {
    main,
    custom,
    customers,
    refund,
    exchanges,
    issue,
    logs,
    refundExchange,
    settings,
    tasks,
    orders,
    products,
    feedback,
    errors,
    scanner,
    alerts,
};